import React from 'react';
import { Alert } from 'antd';
import PropTypes from 'prop-types';

const ResumeUploadedConfirmation = React.memo(({ onAlertClose }) => {
  return (
    <div className='resume-uploaded-alert'>
      <Alert
        description="The new Resume has been uploaded and the information is updated."
        type="success"
        showIcon
        closable
        onClose={onAlertClose}
      />
    </div>
  );
});

ResumeUploadedConfirmation.propTypes = {
  onAlertClose: PropTypes.func.isRequired
};

export default ResumeUploadedConfirmation;
